<template>
  <div class="container">
    <!-- <h1>省级组委会</h1>
    <Table
      class="table"
      border
      :columns="columns1"
      :data="ProvinceGroupInfos"
    ></Table>

    <h1>地市组委会</h1>
    <Table
      class="table"
      border
      align="center"
      :columns="columns1"
      :data="CityGroupInfos"
    ></Table> -->

    <h1>考点信息</h1>
    <Table class="table" border :columns="columns2" :data="CenterInfos"></Table>

    <!-- <h1>报名培训中心</h1>
    <Table
      class="table"
      border
      :columns="columns3"
      :data="SignTrainInfos"
    ></Table> -->
  </div>
</template>

<script>
import CenterInfo from "../../public/CenterInfo.json";
import CityGroupInfo from "../../public/CityGroupInfo.json";
import ProvinceGroupInfo from "../../public/ProvinceGroupInfo.json";
import SignTrainInfo from "../../public/SignTrainInfo.json";
// import { getOrganizeGroupList } from "@/request/api.js";

export default {
  created() {
    this.ProvinceGroupInfos = ProvinceGroupInfo;
    this.CityGroupInfos = CityGroupInfo;
    this.SignTrainInfos = SignTrainInfo;
    this.CenterInfos = CenterInfo;
    // getOrganizeGroupList().then((res) => {
    //   if (res.statusText === "OK") {
    //     this.ProvinceGroupInfos = res.data.ProvinceGroupInfos;
    //     this.CityGroupInfos = res.data.CityGroupInfos;
    //     this.SignTrainInfos = res.data.SignTrainInfos;
    //     this.CenterInfos = res.data.CenterInfos;
    //   }
    // });
  },
  mounted() {
    document.oncontextmenu = new Function("event.returnValue=false");
    document.onselectstart = new Function("event.returnValue=false");
  },
  data() {
    return {
      columns1: [
        {
          title: "联系人",
          key: "LinkPerson",
          align: "center",
          width: 150,
        },
        {
          title: "组织机构",
          key: "GroupName",
          align: "center",
        },
        {
          title: "通讯地址",
          key: "LinkAddress",
          align: "center",
        },
        {
          title: "联系电话",
          key: "LinkPhone",
          align: "center",
          width: 250,
        },
        {
          title: "学段",
          key: "GradeRangeName",
          align: "center",
          width: 150,
        },
      ],
      columns2: [
        {
          title: "联系人",
          key: "LinkPerson",
          align: "center",
          width: 150,
        },
        {
          title: "组织机构",
          key: "GroupName",
          align: "center",
        },
        {
          title: "学校名称",
          key: "CenterName",
          align: "center",
        },
        {
          title: "通讯地址",
          key: "LinkAddress",
          align: "center",
        },
        {
          title: "联系电话",
          key: "LinkPhone",
          align: "center",
          width: 200,
        },
        {
          title: "地区",
          key: "CityName",
          align: "center",
          width: 150,
        },
      ],
      columns3: [
        {
          title: "联系人",
          key: "LinkPerson",
          align: "center",
          width: 150,
        },
        {
          title: "组织机构",
          key: "GroupName",
          align: "center",
        },
        {
          title: "学校名称",
          key: "SignTrainName",
          align: "center",
        },
        {
          title: "通讯地址",
          key: "LinkAddress",
          align: "center",
        },
        {
          title: "联系电话",
          key: "LinkPhone",
          align: "center",
          width: 200,
        },
        {
          title: "地区",
          key: "CityName",
          align: "center",
          width: 150,
        },
      ],
      ProvinceGroupInfos: [],
      CityGroupInfos: [],
      SignTrainInfos: [],
      CenterInfos: [],
    };
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 50px auto;
  margin-top: 0;
  .table {
    margin: 30px 0 0 0;
  }
}
h1 {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  background: #f8f8f9;
  border: #e8eaec solid 1px;
  border-bottom: none;
  width: 1200px;
  transform: translateY(30px);
  font-size: 18px;
  height: 40px;
  color: #333;
}
</style>
<style >
.ivu-table-border td,
.ivu-table-border th {
  background-color: #fff !important;
}
</style>
